import {
  PATIENT_EVENT_SEGMENTS,
  buildPatientEventRawEdi,
} from "./patientEventSegments";

export const CLIENTS = [
  { key: "DEFAULT", displayName: "Default (All Segments)" },
  { key: "AETNA", displayName: "Aetna" },
  { key: "BCBS", displayName: "Blue Cross Blue Shield" },
  { key: "CIGNA", displayName: "Cigna" },
];

const PATIENT_EVENT_RAW = buildPatientEventRawEdi(PATIENT_EVENT_SEGMENTS);

export const CLIENT_OPTIONAL_OVERRIDES = {
  AETNA: ["PER_1P", "MSG_EVENT"],
  BCBS: ["DMG_IL"],
  CIGNA: ["PER_1P", "DMG_IL", "MSG_EVENT"],
};

export const EDI_TEMPLATE = {
  transactionSet: "278",
  implementationGuide: "005010X217",
  rawEdi:
    "ISA*00*          *00*          *ZZ*SUBMITTER      *ZZ*RECEIVER       *250722*1430*^*00501*000000001*0*P*:~" +
    "GS*HI*SUBMITTER*RECEIVER*20250722*1430*1*X*005010X217~" +
    "ST*278*0001*005010X217~" +
    "BHT*0007*22*AUTH123456*20250722*1430*CH~" +
    "HL*1**20*1~" +
    "NM1*PR*2*AETNA HEALTH*****PI*60054~" +
    "PER*IC*EDI SUPPORT*TE*8005551234~" +
    "HL*2*1*21*1~" +
    "NM1*1P*2*REQUESTING PROVIDER*****XX*1234567890~" +
    "PER*1P*CONTACT NAME*TE*5551234567*EM*contact@provider.com~" +
    "HL*3*2*22*0~" +
    "NM1*IL*1*DOE*JOHN****MI*MEM123456789~" +
    "DMG*D8*19850315*M~" +
    PATIENT_EVENT_RAW +
    "HL*5*4*SS*0~" +
    "UM*HS*I*3*11:B:1*22**Y~" +
    "SV1*HC:33510*15000.00*UN*1***1~" +
    "SE*32*0001~" +
    "GE*1*1~" +
    "IEA*1*000000001~",
  loops: [
    {
      loopId: "ENVELOPE",
      name: "Interchange Envelope",
      segments: [
        {
          segmentId: "ISA",
          tag: "ISA",
          raw: "ISA*00*          *00*          *ZZ*SUBMITTER      *ZZ*RECEIVER       *250722*1430*^*00501*000000001*0*P*:~",
          isOptional: false,
          elements: [
            { position: 1, elementId: "ISA01", label: "Authorization Information Qualifier", value: "00", required: true, dataType: "ID" },
            { position: 2, elementId: "ISA02", label: "Authorization Information", value: "          ", required: true, dataType: "AN" },
            { position: 3, elementId: "ISA03", label: "Security Information Qualifier", value: "00", required: true, dataType: "ID" },
            { position: 4, elementId: "ISA04", label: "Security Information", value: "          ", required: true, dataType: "AN" },
            { position: 5, elementId: "ISA05", label: "Interchange ID Qualifier", value: "ZZ", required: true, dataType: "ID" },
            { position: 6, elementId: "ISA06", label: "Interchange Sender ID", value: "SUBMITTER      ", required: true, dataType: "AN" },
            { position: 7, elementId: "ISA07", label: "Interchange ID Qualifier", value: "ZZ", required: true, dataType: "ID" },
            { position: 8, elementId: "ISA08", label: "Interchange Receiver ID", value: "RECEIVER       ", required: true, dataType: "AN" },
            { position: 9, elementId: "ISA09", label: "Interchange Date", value: "250722", required: true, dataType: "DT" },
            { position: 10, elementId: "ISA10", label: "Interchange Time", value: "1430", required: true, dataType: "TM" },
            { position: 11, elementId: "ISA11", label: "Repetition Separator", value: "^", required: true, dataType: "ID" },
            { position: 12, elementId: "ISA12", label: "Interchange Control Version Number", value: "00501", required: true, dataType: "ID" },
            { position: 13, elementId: "ISA13", label: "Interchange Control Number", value: "000000001", required: true, dataType: "N0" },
            { position: 14, elementId: "ISA14", label: "Acknowledgment Requested", value: "0", required: true, dataType: "ID" },
            { position: 15, elementId: "ISA15", label: "Usage Indicator", value: "P", required: true, dataType: "ID" },
            { position: 16, elementId: "ISA16", label: "Component Element Separator", value: ":", required: true, dataType: "ID" },
          ],
        },
        {
          segmentId: "GS",
          tag: "GS",
          raw: "GS*HI*SUBMITTER*RECEIVER*20250722*1430*1*X*005010X217~",
          isOptional: false,
          elements: [
            { position: 1, elementId: "GS01", label: "Functional Identifier Code", value: "HI", required: true, dataType: "ID" },
            { position: 2, elementId: "GS02", label: "Application Sender's Code", value: "SUBMITTER", required: true, dataType: "AN" },
            { position: 3, elementId: "GS03", label: "Application Receiver's Code", value: "RECEIVER", required: true, dataType: "AN" },
            { position: 4, elementId: "GS04", label: "Date", value: "20250722", required: true, dataType: "DT", source: "computed", binding: "FunctionalGroupDate" },
            { position: 5, elementId: "GS05", label: "Time", value: "1430", required: true, dataType: "TM", source: "computed", binding: "FunctionalGroupTime" },
            { position: 6, elementId: "GS06", label: "Group Control Number", value: "1", required: true, dataType: "N0" },
            { position: 7, elementId: "GS07", label: "Responsible Agency Code", value: "X", required: true, dataType: "ID" },
            { position: 8, elementId: "GS08", label: "Version / Release / Industry Identifier Code", value: "005010X217", required: true, dataType: "AN" },
          ],
        },
      ],
    },
    {
      loopId: "HEADER",
      name: "Transaction Header",
      segments: [
        {
          segmentId: "ST",
          tag: "ST",
          raw: "ST*278*0001*005010X217~",
          isOptional: false,
          elements: [
            { position: 1, elementId: "ST01", label: "Transaction Set Identifier Code", value: "278", required: true, dataType: "ID", source: "static", defaultValue: "278" },
            { position: 2, elementId: "ST02", label: "Transaction Set Control Number", value: "0001", required: true, dataType: "AN", source: "computed", binding: "TransactionSetControlNumber" },
            { position: 3, elementId: "ST03", label: "Implementation Convention Reference", value: "005010X217", required: true, dataType: "AN", source: "static", defaultValue: "005010X217" },
          ],
        },
        {
          segmentId: "BHT",
          tag: "BHT",
          raw: "BHT*0007*22*AUTH123456*20250722*1430*CH~",
          isOptional: false,
          elements: [
            { position: 1, elementId: "BHT01", label: "Hierarchical Structure Code", value: "0007", required: true, dataType: "ID" },
            { position: 2, elementId: "BHT02", label: "Transaction Set Purpose Code", value: "22", required: true, dataType: "ID" },
            { position: 3, elementId: "BHT03", label: "Reference Identification", value: "AUTH123456", required: false, dataType: "AN" },
            { position: 4, elementId: "BHT04", label: "Date", value: "20250722", required: true, dataType: "DT" },
            { position: 5, elementId: "BHT05", label: "Time", value: "1430", required: false, dataType: "TM" },
            { position: 6, elementId: "BHT06", label: "Transaction Type Code", value: "CH", required: false, dataType: "ID" },
          ],
        },
      ],
    },
    {
      loopId: "2000A",
      name: "Information Source Level (Payer)",
      segments: [
        {
          segmentId: "HL_2000A",
          tag: "HL",
          raw: "HL*1**20*1~",
          isOptional: false,
          elements: [
            { position: 1, elementId: "HL01", label: "Hierarchical ID Number", value: "1", required: true, dataType: "AN", source: "computed", binding: "HierarchicalId" },
            { position: 3, elementId: "HL03", label: "Hierarchical Level Code", value: "20", required: true, dataType: "ID", source: "static", defaultValue: "20" },
            { position: 4, elementId: "HL04", label: "Hierarchical Child Code", value: "1", required: true, dataType: "ID", source: "static", defaultValue: "1" },
          ],
        },
        {
          segmentId: "NM1_PR",
          tag: "NM1",
          raw: "NM1*PR*2*AETNA HEALTH*****PI*60054~",
          isOptional: false,
          elements: [
            { position: 1, elementId: "NM101", label: "Entity Identifier Code", value: "PR", required: true, dataType: "ID" },
            { position: 2, elementId: "NM102", label: "Entity Type Qualifier", value: "2", required: true, dataType: "ID" },
            { position: 3, elementId: "NM103", label: "Payer Name", value: "AETNA HEALTH", required: true, dataType: "AN" },
            { position: 8, elementId: "NM108", label: "Identification Code Qualifier", value: "PI", required: false, dataType: "ID" },
            { position: 9, elementId: "NM109", label: "Payer Identification", value: "60054", required: false, dataType: "AN" },
          ],
        },
        {
          segmentId: "PER_IC",
          tag: "PER",
          raw: "PER*IC*EDI SUPPORT*TE*8005551234~",
          isOptional: true,
          elements: [
            { position: 1, elementId: "PER01", label: "Contact Function Code", value: "IC", required: true, dataType: "ID" },
            { position: 2, elementId: "PER02", label: "Payer Contact Name", value: "EDI SUPPORT", required: false, dataType: "AN" },
            { position: 3, elementId: "PER03", label: "Communication Number Qualifier", value: "TE", required: false, dataType: "ID" },
            { position: 4, elementId: "PER04", label: "Communication Number", value: "8005551234", required: false, dataType: "AN" },
          ],
        },
      ],
    },
    {
      loopId: "2000B",
      name: "Information Receiver Level (Provider)",
      segments: [
        {
          segmentId: "HL_2000B",
          tag: "HL",
          raw: "HL*2*1*21*1~",
          isOptional: false,
          elements: [
            { position: 1, elementId: "HL01", label: "Hierarchical ID Number", value: "2", required: true, dataType: "AN" },
            { position: 2, elementId: "HL02", label: "Hierarchical Parent ID Number", value: "1", required: true, dataType: "AN" },
            { position: 3, elementId: "HL03", label: "Hierarchical Level Code", value: "21", required: true, dataType: "ID" },
            { position: 4, elementId: "HL04", label: "Hierarchical Child Code", value: "1", required: true, dataType: "ID" },
          ],
        },
        {
          segmentId: "NM1_1P",
          tag: "NM1",
          raw: "NM1*1P*2*REQUESTING PROVIDER*****XX*1234567890~",
          isOptional: false,
          elements: [
            { position: 1, elementId: "NM101", label: "Entity Identifier Code", value: "1P", required: true, dataType: "ID" },
            { position: 2, elementId: "NM102", label: "Entity Type Qualifier", value: "2", required: true, dataType: "ID" },
            { position: 3, elementId: "NM103", label: "Requester Name", value: "REQUESTING PROVIDER", required: true, dataType: "AN" },
            { position: 4, elementId: "NM104", label: "Requester First Name", value: "", required: false, dataType: "AN" },
            { position: 5, elementId: "NM105", label: "Requester Middle Name", value: "", required: false, dataType: "AN" },
            { position: 8, elementId: "NM108", label: "Identification Code Qualifier", value: "XX", required: false, dataType: "ID" },
            { position: 9, elementId: "NM109", label: "Requester NPI", value: "1234567890", required: false, dataType: "AN" },
          ],
        },
        {
          segmentId: "PER_1P",
          tag: "PER",
          raw: "PER*1P*CONTACT NAME*TE*5551234567*EM*contact@provider.com~",
          isOptional: true,
          elements: [
            { position: 1, elementId: "PER01", label: "Contact Function Code", value: "1P", required: true, dataType: "ID" },
            { position: 2, elementId: "PER02", label: "Requester Contact Name", value: "CONTACT NAME", required: false, dataType: "AN" },
            { position: 3, elementId: "PER03", label: "Communication Number Qualifier", value: "TE", required: false, dataType: "ID" },
            { position: 4, elementId: "PER04", label: "Communication Number", value: "5551234567", required: false, dataType: "AN" },
            { position: 5, elementId: "PER05", label: "Communication Number Qualifier", value: "EM", required: false, dataType: "ID" },
            { position: 6, elementId: "PER06", label: "Email Address", value: "contact@provider.com", required: false, dataType: "AN" },
          ],
        },
      ],
    },
    {
      loopId: "2000C",
      name: "Subscriber Level",
      segments: [
        {
          segmentId: "HL_2000C",
          tag: "HL",
          raw: "HL*3*2*22*0~",
          isOptional: false,
          elements: [
            { position: 1, elementId: "HL01", label: "Hierarchical ID Number", value: "3", required: true, dataType: "AN" },
            { position: 2, elementId: "HL02", label: "Hierarchical Parent ID Number", value: "2", required: true, dataType: "AN" },
            { position: 3, elementId: "HL03", label: "Hierarchical Level Code", value: "22", required: true, dataType: "ID" },
            { position: 4, elementId: "HL04", label: "Hierarchical Child Code", value: "0", required: true, dataType: "ID" },
          ],
        },
        {
          segmentId: "NM1_IL",
          tag: "NM1",
          raw: "NM1*IL*1*DOE*JOHN****MI*MEM123456789~",
          isOptional: false,
          elements: [
            { position: 1, elementId: "NM101", label: "Entity Identifier Code", value: "IL", required: true, dataType: "ID" },
            { position: 2, elementId: "NM102", label: "Entity Type Qualifier", value: "1", required: true, dataType: "ID" },
            { position: 3, elementId: "NM103", label: "Subscriber Last Name", value: "DOE", required: true, dataType: "AN" },
            { position: 4, elementId: "NM104", label: "Subscriber First Name", value: "JOHN", required: false, dataType: "AN" },
            { position: 8, elementId: "NM108", label: "Identification Code Qualifier", value: "MI", required: false, dataType: "ID" },
            { position: 9, elementId: "NM109", label: "Member ID", value: "MEM123456789", required: false, dataType: "AN" },
          ],
        },
        {
          segmentId: "DMG_IL",
          tag: "DMG",
          raw: "DMG*D8*19850315*M~",
          isOptional: true,
          elements: [
            { position: 1, elementId: "DMG01", label: "Date Time Period Format Qualifier", value: "D8", required: true, dataType: "ID" },
            { position: 2, elementId: "DMG02", label: "Subscriber Birth Date", value: "19850315", required: true, dataType: "DT" },
            { position: 3, elementId: "DMG03", label: "Subscriber Gender Code", value: "M", required: false, dataType: "ID" },
          ],
        },
      ],
    },
    {
      loopId: "2000E",
      name: "Patient Event Level",
      segments: PATIENT_EVENT_SEGMENTS,
    },
    {
      loopId: "2000F",
      name: "Service Level",
      segments: [
        {
          segmentId: "HL_2000F",
          tag: "HL",
          raw: "HL*5*4*SS*0~",
          isOptional: false,
          elements: [
            { position: 1, elementId: "HL01", label: "Hierarchical ID Number", value: "5", required: true, dataType: "AN" },
            { position: 2, elementId: "HL02", label: "Hierarchical Parent ID Number", value: "4", required: true, dataType: "AN" },
            { position: 3, elementId: "HL03", label: "Hierarchical Level Code", value: "SS", required: true, dataType: "ID" },
            { position: 4, elementId: "HL04", label: "Hierarchical Child Code", value: "0", required: true, dataType: "ID" },
          ],
        },
        {
          segmentId: "SV1",
          tag: "SV1",
          raw: "SV1*HC:99213*150.00*UN*1***1~",
          isOptional: false,
          elements: [
            { position: 1, elementId: "SV101", label: "Composite Medical Procedure Identifier", value: "HC:99213", required: true, dataType: "AN" },
            { position: 2, elementId: "SV102", label: "Line Item Charge Amount", value: "150.00", required: false, dataType: "R" },
            { position: 3, elementId: "SV103", label: "Unit or Basis for Measurement Code", value: "UN", required: false, dataType: "ID" },
            { position: 4, elementId: "SV104", label: "Service Unit Count", value: "1", required: false, dataType: "R" },
            { position: 7, elementId: "SV107", label: "Diagnosis Code Pointer", value: "1", required: false, dataType: "N0" },
          ],
        },
      ],
    },
    {
      loopId: "TRAILER",
      name: "Transaction Trailer",
      segments: [
        {
          segmentId: "SE",
          tag: "SE",
          raw: "SE*18*0001~",
          isOptional: false,
          elements: [
            { position: 1, elementId: "SE01", label: "Number of Included Segments", value: "18", required: true, dataType: "N0", source: "computed", binding: "SegmentCount" },
            { position: 2, elementId: "SE02", label: "Transaction Set Control Number", value: "0001", required: true, dataType: "AN", source: "computed", binding: "TransactionSetControlNumber" },
          ],
        },
        {
          segmentId: "GE",
          tag: "GE",
          raw: "GE*1*1~",
          isOptional: false,
          elements: [
            { position: 1, elementId: "GE01", label: "Number of Transaction Sets Included", value: "1", required: true, dataType: "N0" },
            { position: 2, elementId: "GE02", label: "Group Control Number", value: "1", required: true, dataType: "N0" },
          ],
        },
        {
          segmentId: "IEA",
          tag: "IEA",
          raw: "IEA*1*000000001~",
          isOptional: false,
          elements: [
            { position: 1, elementId: "IEA01", label: "Number of Included Functional Groups", value: "1", required: true, dataType: "N0" },
            { position: 2, elementId: "IEA02", label: "Interchange Control Number", value: "000000001", required: true, dataType: "N0" },
          ],
        },
      ],
    },
  ],
};

export function getVisibleLoops(template, clientKey, hideOptional) {
  const hiddenForClient = CLIENT_OPTIONAL_OVERRIDES[clientKey] ?? [];
  return template.loops
    .map((loop) => ({
      ...loop,
      segments: loop.segments.filter(
        (seg) =>
          !hideOptional ||
          (!seg.isOptional && !hiddenForClient.includes(seg.segmentId))
      ),
    }))
    .filter((loop) => loop.segments.length > 0);
}
